import React from "react";
import styled from "styled-components";
import YourStory from "../../images/Borrower/YourStory.svg";
import VCC from "../../images/Borrower/VCC.svg";
import BWDisrupt from "../../images/Borrower/BWDisrupt.svg";
import Entrepreneur from "../../images/Borrower/Entrepreneur.svg";
import ENTrackr from "../../images/Borrower/ENTrackr.svg";
import inc42 from "../../images/Borrower/inc42.svg";

const StyledWrapper = styled.section`
  margin: 0 15px 0 20px;
  color: #000000;
  font-family: Inter;

  .wrapper {
    background-color: #ffb891;
    padding: 3.5rem 0 1.7rem;
    border-radius: 19px;

    @media (max-width: 768px) {
      padding: 3rem 0 3rem;
    }
  }

  @media (max-width: 768px) {
    margin-bottom: 0 !important;
  }

  .heading {
    font-size: 45px;
    font-weight: 700;
    line-height: 44px;
    letter-spacing: 0em;
    text-align: left;
    padding-left: 45px;
    margin-bottom: 112px;
    @media (max-width: 768px) {
      font-size: 30px;
      line-height: 36px;
      padding-left: 0;
      margin-bottom: 16px;
    }
  }

  .img-content {
    font-size: 16px;
    font-weight: 400;
    line-height: 25px;
    letter-spacing: 0em;
    text-align: left;
    text-decoration: None;
    color: #000000;
    :hover {
      text-decoration: None;
      color: #000000;
    }
  }

  a {
    text-decoration: None;
  }

  .img-container {
    max-height: 50px;
    cursor: pointer;
  }

  img,
  svg {
    max-height: 50px;
    cursor: pointer;
  }

  .logoContainer {
    max-width: 1670px;
    margin: 0 auto 40px;
    justify-content: space-evenly;
    align-items: center;
    flex-wrap: nowrap;
    position: relative;
    & > * {
      flex: 0 auto;
      min-width: 0;
      min-height: 100px;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      width: auto;
    }
    @media (max-width: 1250px) {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(200px, 250px));
      grid-row-gap: 3.5rem;
    }
    @media (max-width: 768px) {
      padding: unset;
      margin: 0 auto;
    }
  }
`;

const Featured = () => {
  const articles = [
    {
      img: YourStory,
      link: "https://yourstory.com/2021/10/funding-alert-fintech-startup-niro-seed-investment-elevar-equity/amp",
      content: "Yourstory Media",
    },
    {
      img: Entrepreneur,
      link: "https://www.entrepreneur.com/article/390890",
      content: "Entrepreneur India",
    },
    {
      img: VCC,
      link: "https://www.vccircle.com/fintech-startup-niro-raises-funds-from-elevar-equity-kunal-shah-others",
      content: "VCC circle",
    },
    {
      img: inc42,
      link: "https://inc42.com/buzz/embedded-finance-startup-niro-raises-a-3-5-mn-seed-round-from-founders-of-cred-uni-freo/amp/",
      content: "Inc 42",
    },
    {
      img: ENTrackr,
      link: "https://entrackr.com/2021/10/elevar-equity-leads-3-5-mn-seed-round-in-fintech-startup-niro/",
      content: "Entrackr",
    },
    {
      img: BWDisrupt,
      link: "http://bwdisrupt.businessworld.in/article/Niro-Raises-3-5-Mn-Seed-Funding/13-10-2021-408543/",
      content: "BW Disrupt",
    },
  ];
  return (
    <StyledWrapper>
      <div className="heading d-md-none">Featured in:</div>
      <div className="wrapper">
        <div className="container-fluid">
          <div className="row d-md-flex d-none">
            <div className="heading">Featured in:</div>
          </div>
          <div className="row logoContainer">
            {articles.map((item, i) => (
              <a
                href={item.link}
                rel="noreferrer noopener"
                target="_blank"
                key={i}
              >
                <div className="img-container">
                  <img src={item.img} alt="" />
                </div>
                <div className="img-content">{item.content}</div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </StyledWrapper>
  );
};

export default Featured;
